import { AtividadeColetivaGrupoSelectQuery } from 'graphql/types.generated'

export enum AtividadeColetivaGrupoCabecalho {
  MEUS_GRUPOS = 'MEUS_GRUPOS',
  OUTROS_GRUPOS = 'OUTROS_GRUPOS',
}

export enum AtividadeColetivaGrupoSemResultados {
  SEM_RESULTADOS_ENCONTRADOS = 'SEM_RESULTADOS_ENCONTRADOS',
}

export type CidadaoGrupoItemModel = AtividadeColetivaGrupoSelectQuery['gruposParticipantesAtividadeColetiva']['content'][0]['cidadaosParticipantes'][0]
export type LotacaoGrupoItemModel = AtividadeColetivaGrupoSelectQuery['gruposParticipantesAtividadeColetiva']['content'][0]['lotacoesEnvolvidas'][0]

export type AtividadeColetivaGrupoItemModel = {
  nome: string
  equipesEnvolvidas: string
  unidadeDeSaude: string
  cidadaos: ReadonlyArray<CidadaoGrupoItemModel>
  lotacoes: ReadonlyArray<LotacaoGrupoItemModel>
}

export type AtividadeColetivaGrupoSelectItemModel =
  | AtividadeColetivaGrupoCabecalho
  | AtividadeColetivaGrupoSemResultados
  | AtividadeColetivaGrupoItemModel
